import type { OrgLocation } from "@/config/locations";

export type OrgLocationPickerOption = { id: string; label: string };

export function orgLocationPickerLabel(
  options: OrgLocationPickerOption[],
  id: string
): string {
  return options.find((o) => o.id === id)?.label ?? id;
}

/** Org DB locations first, then static catalog ids that are not already in the org list. */
export function orgLocationPickerOptions(
  orgRows: Array<{ id: string; name: string; city?: string | null }>,
  staticLots: OrgLocation[]
): OrgLocationPickerOption[] {
  const out: OrgLocationPickerOption[] = [];
  const seen = new Set<string>();
  for (const row of orgRows) {
    const id = String(row.id ?? "").trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    const name = String(row.name ?? "").trim() || id;
    const city = String(row.city ?? "").trim();
    out.push({ id, label: city && city.toLowerCase() !== name.toLowerCase() ? `${name} · ${city}` : name });
  }
  for (const loc of staticLots) {
    if (seen.has(loc.id)) continue;
    seen.add(loc.id);
    out.push({ id: loc.id, label: loc.fullName || loc.city || loc.id });
  }
  return out.sort((a, b) => a.label.localeCompare(b.label));
}
